import { LatLng } from '@/parsing/Log';
import { LogEntry } from '@/parsing/LogEntry';

export interface TimelineMarker {
  markerId: number;
  logEntry: LogEntry;
  alternativeLogEntry?: LogEntry;

  startTimeMs: number;
  endTimeMs: number | undefined;

  fillColor: string;

  textOnMarker: string | undefined;
  textOnMarkerColor: string | undefined;
  tooltipContent: string | undefined;
}

export interface TimelineRow {
  markers: TimelineMarker[];
}

export interface TimelineRowGroup {
  name: string;
  rows: TimelineRow[];
  expanded: boolean;
}

export interface TimelineData {
  logId: string;

  startTimeMs: number;
  endTimeMs: number;

  rowGroups: TimelineRowGroup[];
}

export interface GpsHistoryLocationTimelineMarker extends TimelineMarker {
  gpsHistoryLocationIndex: number;
}

export function isGpsHistoryLocationTimelineMarker(marker: TimelineMarker): boolean {
  return typeof (marker as any).gpsHistoryLocationIndex !== 'undefined';
}

export interface MapEventInfo {
  logEntryIndex: number;
  timeMs: number;
  mapContext: string;
  frame: {
    x: number;
    y: number;
    w: number;
    h: number;
  };
  padding: {
    top: number;
    left: number;
    right: number;
    bottom: number;
  };
  viewportBounds: {
    ne: LatLng;
    sw: LatLng;
  };
  center: LatLng;
  zoom: number;
}

export interface MapEventTimelineMarker extends TimelineMarker, MapEventInfo {}

export function isMapEventTimelineMarker(marker: TimelineMarker): boolean {
  return typeof (marker as any).mapContext !== 'undefined';
}

export interface MapEventAnimationTimelineMarker extends TimelineMarker {
  mapEvents: MapEventInfo[];
}

export function isMapEventAnimationTimelineMarker(marker: TimelineMarker): boolean {
  return typeof (marker as any).mapEvents !== 'undefined';
}
